module.exports = __webpack_public_path__ + "img/our_legacy_our_evolution.da0dc901.png";